import { StaticImage } from 'gatsby-plugin-image';

export const Logo = () => (
  <StaticImage src="./logo.png" alt="DoctorDent" width={100} height={34} />
);
